/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningspayoutcontested2Inputs */

const en_earningspayoutcontested2 = /** @type {(inputs: Earningspayoutcontested2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On hold, a payment is disputed`)
};

const de_earningspayoutcontested2 = /** @type {(inputs: Earningspayoutcontested2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartet, eine Zahlung ist bestritten`)
};

/**
* | output |
* | --- |
* | "On hold, a payment is disputed" |
*
* @param {Earningspayoutcontested2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspayoutcontested2 = /** @type {((inputs?: Earningspayoutcontested2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspayoutcontested2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspayoutcontested2(inputs)
	return de_earningspayoutcontested2(inputs)
});
export { earningspayoutcontested2 as "earningsPayoutContested" }